import { useEffect } from "react";

export function useBindKeys(callback: () => void, keyCodes: string[], dependencies: any[] = [], controlModifier = false, shiftModifier = false): void {
  const handler = (e: KeyboardEvent) => {
    const code = e.code;
    const isControlOk = (controlModifier && e.ctrlKey) || !controlModifier;
    const isShiftOk = (shiftModifier && e.shiftKey) || !shiftModifier;
    if (keyCodes.includes(code) && isControlOk && isShiftOk) {
      callback();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handler);
    return () => {
      window.removeEventListener("keydown", handler);
    };
  }, dependencies);
}
